import { render, staticRenderFns } from "./AsignacionArma.vue?vue&type=template&id=0dd004d4"
import script from "./AsignacionArma.vue?vue&type=script&lang=js"
export * from "./AsignacionArma.vue?vue&type=script&lang=js"
import style0 from "./AsignacionArma.vue?vue&type=style&index=0&id=0dd004d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports